import { Component, OnInit, HostListener } from '@angular/core';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { HealthSafetyService } from '../../../services/health-safety.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { IstatusCountData, IOnDemandClassesWrapper, IOnDemandClassesUpdateWrapper, IOnDemandClassesEquipment } from '../../../services/on-demand-classes.service.model';
import { Router } from '@angular/router';
import { SelectionInfo } from 'src/app/post-login/selectors/multi-selection/multi-selection.model';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { PreviewModalData } from 'src/app/post-login/preview-modal/preview-modal.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-staff-cleaning',
  templateUrl: './staff-cleaning.component.html',
  styleUrls: ['./staff-cleaning.component.scss']
})
export class StaffCleaningComponent implements OnInit {
  private selectionInfo: SelectionInfo;

  toggleMsg: string;
  hasCustomize: boolean = false;
  displayPreviewModal: boolean = false;
  showDisableModal: boolean = false;
  showOutdatedSoftwareModal: boolean = false;

  staffCleaningData: IOnDemandClassesWrapper;
  postOnDemandData: IOnDemandClassesUpdateWrapper;

  productInfoGridData: IOnDemandClassesEquipment[];
  statusCountData: IstatusCountData;
  isEquipmentListFetched: boolean = false;
  viewPreview: boolean = false;
  assetList = [];
  outdatedSoftwarePopupProperties = {};
  isPremium = false;
  productInfoHeaderData = [
    { columnName: 'PRODUCT.INFORMATION' },
    { columnName: 'STATUS' },
    { columnName: 'CONFIRMATION' },
    { columnName: 'SELECT.ALL.EQUIPMENT' },
  ];
  productInfoHeaderDataForXs = [{ columnName: 'STATUS' }, { columnName: 'SELECT.ALL.EQUIPMENT' }];

  tabName = this.commonUtil.translateText('STAFF.CLEANING').toLowerCase();

  disabledPopupProperties = {
    title: this.commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.HEADER', [this.tabName]),
    message: this.commonUtil.replaceValueAsHTMLOnTranslatedText('DISABLE.HEALTH.SAFETY.MSG', [this.tabName, this.tabName, this.tabName]),
    isWarningPopup: false,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };

  constructor(
    private commonUtil: CommonUtil,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private healthSafetyService: HealthSafetyService,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private _router: Router) { }

  ngOnInit(): void {
    this.toggleMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('HEALTH.SAFETY.TOGGLE.MSG', [this.commonUtil.translateText('STAFF.CLEANING').toLowerCase(), this.commonUtil.translateText('STAFF.CLEANING').toLowerCase()]);
  }

  getStaffCleanData(): void {
    // user permission
    this.hasCustomize = (this.selectionInfo.facility.summary.userRights.customize === 'F');
    this.loader.startProcess();
    this.healthSafetyService
      .getStaffCleaningData(this.selectionInfo.facility.facilityId, this.selectionInfo.consoleType)
      .subscribe(
        (data: IOnDemandClassesWrapper) => {
          this.loader.endProcess();
          data.equipmentList.forEach(val => {
            val.assetList.forEach(asset => {
              asset.hasUserPermission =  this.updateAssetUserPermission('lfodEnabledEquipment');
            })
          })
          this.staffCleaningData = data;
          this.isEquipmentListFetched = true;
          this.constructDataForProductInfoGrid(this.staffCleaningData);
          this.constructDataForStatusLegend(this.staffCleaningData);
        },
        error => {
          console.error('API failed.');
          this.loader.endProcess();
        }
      );
  }

  updateAssetUserPermission(permissionType: string){
    let userPermission = false;
    userPermission = (this.selectionInfo.facility?.summary?.userRights.hasOwnProperty(permissionType) && 
    (this.selectionInfo.facility?.summary?.userRights as any)[permissionType] === 'F') ||
    this.selectionInfo.facility?.summary?.isLoggedInManagerAdmin === 'true';
   return userPermission;
  }

  constructDataForStatusLegend(data: IOnDemandClassesWrapper): void {
    this.statusCountData = {
      connectedCount: data.connectedCount,
      idleCount: data.idleCount,
      notConnectedCount: data.notConnectedCount,
      showIdle: false
    };
  }

  constructDataForProductInfoGrid(data: IOnDemandClassesWrapper): void {
    if (data.equipmentList) {
      this.productInfoGridData = data.equipmentList.map((x: IOnDemandClassesEquipment) => {
        x.assetList = x.assetList.map((a) => {
          if (a.updatedDate) {
            a.updatedDate = this.commonUtil.localizeDate(Number(a.updatedDate));
          }
          if (a.onlineStatus === 'C') {
            a.publishedStatusWarning = false;
            if (a.enabledStatus === 'true') {
              a.publishedStatus = this.commonUtil.translateText('ENABLED');
            } else if (a.enabledStatus === 'false') {
              a.publishedStatus = this.commonUtil.translateText('DISABLED');
            } else {
              a.publishedStatus = '';
            }
          } else if (a.onlineStatus === 'NC') {
            a.publishedStatusWarning = true;
            if (a.enabledStatus === 'true') {
              a.publishedStatus = this.commonUtil.translateText('ENABLED.NOT.CONNECTED');
            } else if (a.enabledStatus === 'false') {
              a.publishedStatus = this.commonUtil.translateText('DISABLED.NOT.CONNECTED');
            } else {
              a.publishedStatus = '';
              a.publishedStatusWarning = false;
            }
          } else {
            a.publishedStatus = '';
            a.publishedStatusWarning = false;
          }
          a.currentConsole = this.selectionInfo.consoleType.toUpperCase();
          return a;
        });
        return x;
      });
    }
  }

  assetListDataHandler(assetData: never): void {
    this.assetList = assetData;
    if (this.assetList.length > 0) {
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }

  captureAmpAnalytics() {
    //
  }

  saveStaffCleaning(enableFlag: boolean): void {
    if (!enableFlag) {
      if (this.staffCleaningData.enabledStatus === 'true') {
        this.staffCleaningData.enabledStatus = 'false';
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
        this.showDisableModal = true;
      }
    }
    else {
      this.staffCleaningData.enabledStatus = 'true';
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }

  onPositiveConfirmation() {
    this.showDisableModal = false;
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  closeDisabledModal() {
    this.staffCleaningData.enabledStatus = 'true';
    this.showDisableModal = false;
  }

  setOutdatedSoftwarePopupData() {
    const assetCount: string = JSON.stringify(this.staffCleaningData.outdatedAssetCount);
    this.outdatedSoftwarePopupProperties = {
      title: 'OUTDATED.SOFTWARE.VERSION',
      message: this.commonUtil.replaceValueAsHTMLOnTranslatedText('OUTDATED.SOFTWARE.VERSION.COMMON.MSG', [
        this.commonUtil.translateText('STAFF.CLEANING'),
        assetCount,
        '4.14',
      ]),
      needHelp: 'NEED.HELP',
      needHelpLink: 'https://halofitness.zendesk.com/hc/en-us/articles/360031436651',
      isWarningPopup: true,
      ctaButtonLabel: 'UPDATE.SOFTWARE',
      negativeButtonLabel: 'OK',
      isCloseIconCallsCta: false,
      isSecondaryTextButton: true,
    };
  }

  goToSofwarePage() {
    this._router.navigate(['/software']);
  }

  closeOutdatedSoftwareModal() {
    this.showOutdatedSoftwareModal = false;
  }

  publishStaffCleaning() {
    // this.childProductInfoGrid.getAssetValues();
    const finalInput = {
      facilityId: this.selectionInfo.facility.facilityId,
      consoleType: this.selectionInfo.consoleType,
      enabledStatus: (this.staffCleaningData.enabledStatus === 'true') ? true : false,
      assetIds: this.assetList,
    };
    this.loader.startProcess();
    this.healthSafetyService.publishStaffCleaningData(finalInput).subscribe(
      (data: IOnDemandClassesWrapper) => {
        this.staffCleaningData = data;
        this.constructDataForProductInfoGrid(this.staffCleaningData);
        this.constructDataForStatusLegend(this.staffCleaningData);
        this.loader.endProcess();
        if (this.staffCleaningData.outdatedAssetCount && this.staffCleaningData.outdatedAssetCount > 0) {
          this.showOutdatedSoftwareModal = true;
          this.setOutdatedSoftwarePopupData();
        } else {
          //this.selectionInfo.facility.summary.hasHealthSafetySetup = 'true';//should be changed to banner variable
          if (this.staffCleaningData.enabledStatus === 'true') {
            // this.amplitudeAnalytics.logEvent(
            //   'Staff Cleaning- Enable - Publish', { Console_Type: this.selectionInfo.consoleType }
            // );
            this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('HEALTH.SAFETY.PUBLISH.SUCCESS', [this.tabName]));
          } else {
            // this.amplitudeAnalytics.logEvent(
            //   'Staff Cleaning - Disable - Publish', { Console_Type: this.selectionInfo.consoleType }
            // );
            this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('HEALTH.SAFETY.DISABLED.SUCCESS', [this.tabName]));
          }
          this.selectionInfo.facility.summary.hasHealthSafetySetup = 'true';
        }
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
      },
      error => {
        this.loader.endProcess();
        console.error('API failed.');
      }
    );
  }

  showPreviewPopup() {
    this.displayPreviewModal = true;
    this.viewPreview = true;
  }

  showTapCombPopup() {
    this.displayPreviewModal = true;
    this.viewPreview = false;
  }

  onPressofCancel() {
    this.displayPreviewModal = false;
  }

  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.getStaffCleanData();
    });
  } 
  
  getPreviewData(isPreview: boolean): PreviewModalData[] {
    if(isPreview) return [{
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITH.ON.DEMAND', [this.commonUtil.translateText('STAFF.CLEANING')]),
        images: [
          `${environment.cloudBasePath}/Images/Image_StaffCleaning_ViewOnConsole_Enabled_Step1.png`,
          `${environment.cloudBasePath}/Images/Image_StaffCleaning_ViewOnConsole_Enabled_Step2.png`,
          `${environment.cloudBasePath}/Images/Image_StaffCleaning_ViewOnConsole_Enabled_Step3.png`
        ],
        index: 0
      }, {
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITHOUT.ON.DEMAND', [this.commonUtil.translateText('STAFF.CLEANING')]),
        images: [`${environment.cloudBasePath}/Images/Image_StaffCleaning_ViewOnConsole_Disabled.png`],
        index: 1
      }
    ]; 
    return [{
        images: [`${environment.cloudBasePath}/Images/Image_StaffCleaning_ViewOnConsole_Enabled_Step2.png`],
        index: 0
      }
    ];
  }
}
